export function useConfig() {
    return useAsyncData('config', () => $fetch('/api/config'))
}
